import React from 'react';
import Loadable from 'react-loadable';
import LoadableLoading from '../../components/LoadableLoading';
import { path as PageApplicationListPath } from '../PageApplicationList';
import { ILoadedProps, IProps } from './interfaces';
import { isMobile } from 'react-device-detect';
import { Redirect } from 'react-router-dom';

export const path = '/reports/mo';

const getPage = () => {
  return import(`./page`);
};

const PageMoReportsList: React.FC<IProps> = (props) => {
  if (isMobile) {
    return <Redirect to={PageApplicationListPath} />;
  }

  const LoadableMap = Loadable.Map({
    loader: {
      page: () => getPage(),
      i18n: () => import(`./ru.json`),
    },
    loading: LoadableLoading,
    render(loaded: ILoadedProps, loadedProps): React.ReactNode {
      const Page: any = loaded.page.default;

      return <Page {...loadedProps} {...props} i18n={{ ...loaded.i18n }} />;
    },
  });

  return <LoadableMap {...props} />;
};

export default PageMoReportsList;
